import { LotAddendumIncentiveApplicationMethod } from '../enums/dsm-asp-incentives.enums';

export interface DsmLotIncentiveSummary {
  total: number;
  used: number;
  remaining: number;
}

export interface DsmLotIncentive extends DsmLotIncentiveSummary {
  lotId: string;
}

export interface DsmAddendumIncentivePreviewProduct {
  id: string;
  lineNumber: number;
  productCode: string;
  amount: number;
  incentiveAmount: number;
}

export interface DsmAddendumIncentivePreview {
  addendumId: string;
  requestedAmount: number;
  allocatedAmount: number;
  remainderToPool: number;
  products: DsmAddendumIncentivePreviewProduct[];
}

export interface DsmAddendumIncentivePreviewPayload {
  amount: number;
  method: LotAddendumIncentiveApplicationMethod;
}

export interface DsmApplyAddendumIncentivePayload {
  amount: number;
  method: LotAddendumIncentiveApplicationMethod;
}

export interface DsmIncentiveMethodOption {
  label: string;
  value: LotAddendumIncentiveApplicationMethod;
  description: string;
}

export const DSM_INCENTIVE_METHOD_OPTIONS: DsmIncentiveMethodOption[] = [
  {
    label: 'Highest cost first',
    value: LotAddendumIncentiveApplicationMethod['Highest cost first'],
    description: 'Fills the most expensive option first until the amount runs out.'
  },
  {
    label: 'Order added',
    value: LotAddendumIncentiveApplicationMethod['Order added'],
    description: 'Fills options in the order they were added to the addendum.'
  }
];
